import Splide from "@splidejs/splide";
import '@splidejs/splide/css';
document.addEventListener('DOMContentLoaded', function () {
    //accordion
    var details = Array.from(document.querySelectorAll(".abi-transHerDetails__profileStatsContainer"));
    if (details.length) {
        details.forEach(function (detail) {
            detail.addEventListener("click", function (e) {
                var _a;
                var active = details.find(function (d) { return d.open; });
                if (!((_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.open) && active) {
                    active.open = false;
                }
            });
        });
    }
    // Players  slider
    var playerSection = document.querySelector('.abi-transHerPlayers__slider');
    if (playerSection) {
        var players = playerSection.querySelectorAll('.splide__slide');
        players.forEach(function (player) {
            var lastTap = 0;
            var timeout;
            /* Regex test to determine if user is on mobile */
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                player.addEventListener('touchend', function (event) {
                    var currentTime = new Date().getTime();
                    var tapLength = currentTime - lastTap;
                    event.preventDefault();
                    player.classList.add('flip');
                    if (tapLength < 700 && tapLength > 0) {
                        window.location.href = player.href;
                        player.classList.remove('flip');
                    }
                    else {
                        timeout = window.setTimeout(function () {
                            clearTimeout(timeout);
                            player.classList.toggle('flip');
                        }, 700);
                    }
                    lastTap = currentTime;
                }, { passive: false });
            }
        });
        var playerSlider = new Splide(playerSection, {
            gap: 24,
            pagination: true,
            arrows: false,
            perPage: 2,
            perMove: 2,
            width: 328,
            fixedWidth: 152,
            mediaQuery: 'min',
            breakpoints: {
                1024: {
                    width: 856,
                    pagination: false,
                    arrows: true,
                }
            }
        });
        playerSlider.on('pagination:mounted', function (data) {
            // You can add your class to the UL element
            data.list.classList.add('splide__pagination--counter');
            // `items` contains all dot items
            data.items.forEach(function (item) {
                item.button.textContent = (0 + String(item.page + 1)).slice(-2);
            });
            var paginationButtons = document.querySelectorAll('.splide__pagination__page');
            paginationButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    var buttonNumber = button.textContent;
                    //@ts-ignore
                    dataLayer.push({
                        'event': 'GAEvent',
                        'event_category': 'Content',
                        'event_action': 'Card',
                        'event_label': "".concat(buttonNumber, "-Meet more players"),
                        'interaction': 'true',
                        'component_name': 'Transher_Players',
                        'element_text': buttonNumber
                    });
                });
            });
        });
        playerSlider.mount();
    }
});
